import Loader from "./../../Components/Loader/PageLoader";
import InfoTag from "./../../Components/SendMoney/InfoTag";
import {
  METHOD_TAG_APPROVED_CLASS,
  TAG_INFO,
} from "./../../Utils/Contant";
import { Input } from "./../../Components/ui/input";
import { useOverview } from "./../../hooks";
import { Search, Trash2 } from "lucide-react";
import React, { useEffect, useMemo, useState } from "react";

function BenificaryList() {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);

  const { useBeneficiaryDetails, handleDeleteClick, deleting } = useOverview();

  const { data: beneficiaryData, isLoading: beneficiaryDataIsLoading } =
    useBeneficiaryDetails({ status: undefined });

  const totalPayee = useMemo(() => {
    return beneficiaryData?.data?.beneficiaries?.filter(
      (user) => user?.status?.trim()?.toUpperCase() !== "DELETED"
    )?.length;
  }, [beneficiaryData]);

  useEffect(() => {
    setFilteredUsers(
      beneficiaryData?.data?.beneficiaries?.filter(
        (user) =>
          user?.status?.trim()?.toUpperCase() !== "DELETED" &&
          (!searchTerm ||
            user?.nameOfBeni?.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    );
  }, [deleting, setFilteredUsers, beneficiaryData, searchTerm]);

  return (
    <>
      <div className="relative">
        <div className="text-[16px] font-geomanistBold my-2 ">
          {totalPayee} Payees
        </div>
        <div className="w-full max-w-md mx-auto space-y-4 mb-5 ">
          <div className="relative">
            <Input
              placeholder="Search here"
              className="pl-4"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search className="absolute right-5 top-3 h-4 w-4 text-muted-foreground" />
          </div>

          {beneficiaryDataIsLoading ? (
            <div className="flex items-center justify-center h-40 ">
              <Loader className=" h-20 w-20" />
            </div>
          ) : (
            filteredUsers?.map((beneficiary, index) => {
              const isUnderReview =
                beneficiary?.status?.trim()?.toUpperCase() === "MANUAL_REVIEW";
              const method = (
                beneficiary?.method ||
                beneficiary?.beniConfigCountry?.method ||
                ""
              ).toUpperCase();
              return (
              <div
                key={index}
                //   onClick={() => {
                //     setBeneficiarySelected(beneficiary);
                //     setStateVariable(stateVariable + 1);
                //   }}
                className={`rounded-lg  border border-LightGreyBorder text-card-foreground ${
                  isUnderReview ? "bg-greyShade" : "bg-card"
                } ${
                  beneficiary?.status === "REJECTED" ? "border-red-500" : ""
                } `}
              >
                <div className="flex items-center p-4">
                  <div className="flex-shrink-0 mr-4 text-2xl">
                    {/* <img
                            src={getFlagByCurrencyCode(beneficiary?.country)}
                            alt=""
                            className="w-8 h-8 flex items-center justify-center mr-3"
                          /> */}
                  </div>
                  <div className="flex-grow min-w-0">
                    <div className="flex items-center gap-2">
                      <h3
                        className={`font-normal text-blackShade truncate ${
                          isUnderReview ? "opacity-60" : ""
                        }`}
                      >
                        {beneficiary?.nameOfBeni}
                      </h3>
                      {method && (
                        <InfoTag
                          label={method}
                          info={isUnderReview ? TAG_INFO.MANUAL_REVIEW : undefined}
                          className={
                            isUnderReview ? "" : METHOD_TAG_APPROVED_CLASS
                          }
                        />
                      )}
                    </div>
                    <p
                      className={`text-xs text-muted-foreground ${
                        isUnderReview ? "opacity-60" : ""
                      }`}
                    >
                      <span className="text-blackShade mr-1.5">
                        {beneficiary?.maskAccountNo}
                      </span>
                      <span className=" text-greyish text-xs font-normal">
                        {beneficiary?.bankName}
                      </span>
                    </p>
                  </div>
                  <div className="flex-shrink-0 flex items-center">
                    <span
                      title={beneficiary?.errorMsg?.replace(/[_"]/g, "")}
                      className="text-red-500 text-xs font-normal overflow-hidden truncate max-w-[150px] cursor-pointer"
                    >
       
                      {beneficiary?.errorMsg?.replace(/[_"]/g, "")}
                    </span>
                    <button
                      onClick={(e) =>
                        !isUnderReview && handleDeleteClick(beneficiary, e)
                      }
                      disabled={isUnderReview}
                      className={`p-2 bg-greyShade rounded-full ml-2 transition-colors ${
                        isUnderReview
                          ? "cursor-not-allowed bg-gray-200"
                          : "hover:bg-gray-200"
                      }`}
                    >
                      <Trash2
                        size={18}
                        className={
                          isUnderReview ? "text-gray-400" : "text-red-500"
                        }
                      />
                    </button>
                  </div>
                </div>
              </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
}

export default BenificaryList;
